export class Icons {
    id: number;
    name: string;
    icon: string;
    activated: boolean;

    constructor(id: number, name: string, icon:string, activated: boolean){
        this.id = id;
        this.name = name;
        this.icon = icon;
        this.activated = activated;
    }
}
